import { type FunctionComponent } from 'react'
import styled from '@emotion/styled'
import { ModalBody } from '@retailer-platform/shared-components'
import { CloseIcon } from '@instacart/ids-core'
import {
  spacing,
  TextTitleRow,
  IconButton,
  Text,
  Flex,
} from '@retailer-platform/shared-components/src/tds'
import { useDashMessages } from '../../../../intl/intl.hooks'
import ConfirmationCheckMark from '../../../../assets/ConfirmationCheckmark.png'
import { PartnerNamesTextArea } from './PartnerNamesTextArea'

const ConfirmationImage = styled.img({
  width: '18%',
  height: '18%',
  objectFit: 'contain',
  marginBottom: '16px',
})

export interface ConfirmationPageProps {
  partnerNames?: string[]
  onClose: () => void
}

export const ConfirmationPage: FunctionComponent<ConfirmationPageProps> = ({
  partnerNames,
  onClose,
}) => {
  const messages = useDashMessages({
    title: 'partnerWriteAccess.breakglassModal.confirmation.title',
    closeModalLabel: 'partnerWriteAccess.breakglassModal.closeModalLabel',
    body: 'partnerWriteAccess.breakglassModal.confirmation.body',
    successAlt: 'common.alt.success',
  })

  return (
    <>
      <Flex.Column padding={spacing.s24} width="100%">
        <TextTitleRow
          title={messages.title}
          titleTextProps={{ as: 'h1' }}
          rightSection={
            <IconButton
              icon={CloseIcon}
              onClick={onClose}
              variant="unstyled"
              aria-label={messages.closeModalLabel}
            />
          }
        />
      </Flex.Column>
      <ModalBody
        css={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          minHeight: '252px',
        }}
      >
        <ConfirmationImage src={ConfirmationCheckMark} alt={messages.successAlt} />
        <Flex.Column gap={spacing.s8} css={{ alignItems: 'flex-start' }}>
          <Text as="span" typography="bodyRegular">
            {messages.body}
          </Text>
          <PartnerNamesTextArea isConfirmationPage partnerNames={partnerNames} />
        </Flex.Column>
      </ModalBody>
    </>
  )
}
